import axios from '../config.js';
const resource = '/case/consultation/request';

export default {
  create(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.post(resource, payload);
  },
};